import type { CommonFilterCategories, BaseFilterDisplayType, FilterStateType } from '../types';
import type { BadgeProps } from '@workramp/ui';

export const COMMON_FILTERS: Record<CommonFilterCategories, BaseFilterDisplayType> = {
  status: { label: 'Status', iconName: 'activity:regular' },
  group: { label: 'Group', iconName: 'group:regular' },
  user: { label: 'User', iconName: 'person:regular' },
  manager: { label: 'Manager', iconName: 'team:regular' },
  assigner: { label: 'Assigner', iconName: 'filter-token-line:regular' },
  dueDate: { label: 'Due Date', iconName: 'calendar:regular' },
  customAttribute: { label: 'Custom Attribute', iconName: 'filter-token-line:regular' },
};

export const DEFAULT_INITIAL_STATE: FilterStateType = {
  status: [],
  user: [],
  group: [],
  manager: [],
  assigner: null,
  dueDate: null,
  customAttribute: null,
  reviewer: [],
  reviewerDueDate: null,
  aiReviewer: null,
  archived: null,
  session: [],
  dateRegistered: null,
  createdBy: [],
  updatedBy: [],
  assetTypes: [],
  createdAt: null,
  updatedAt: null,
};

export const REVIEWER_STATUS_NAMES: Record<string, string> = {
  not_submitted: 'Not Submitted',
  submitted: 'Submitted',
};

export const REVIEWER_STATUS_COLORS: Record<string, BadgeProps['variant']> = {
  not_submitted: 'neutral',
  submitted: 'success',
};

export const MIN_FILTER_WIDTH = 320;

export const ITEMS_PER_PAGE = 20;
export const ITEMS_PER_PAGE_OPTIONS = [ITEMS_PER_PAGE, 50, 100];

export const SCHEDULED_ASSIGNMENTS_PER_PAGE = 100;

export const MIXPANEL_ASSIGN_CONTENT = 'admin_assign_content';

export const MIXPANEL_CREATE_SCHEDULED_ASSIGNMENT_EVENT = 'admin_create_scheduled_assignment';
export const MIXPANEL_UPDATE_SCHEDULED_ASSIGNMENT_EVENT = 'admin_update_scheduled_assignment';
export const MIXPANEL_DELETE_SCHEDULED_ASSIGNMENT_EVENT = 'admin_delete_scheduled_assignment';

export const MIXPANEL_HIDE_CONTENT = 'admin_hide_content';
export const MIXPANEL_RESTORE_CONTENT = 'admin_restore_content';

export const NAME_COLUMN_WIDTH = 456;

export const NO_ASSIGNMENTS_MESSAGE = 'There are no users currently assigned.';
export const EMPTY_RESULTS_MESSAGE = 'There are no users that fit this criteria, please change the filter settings.';

export const USER_SEARCH_PLACEHOLDER = 'Search by name or email';
export const GROUP_SEARCH_PLACEHOLDER = 'Search by group name';
export const AUTOMATION_SEARCH_PLACEHOLDER = 'Search by automation name';

export const USER_PROFILE_ROUTE = '/admin/users';

export const HIDE_CONTENT_LEARN_MORE_LINK = 'http://help.workramp.com/en/articles/10045762-hide-content';
